import { render, staticRenderFns } from "./unboundPhone.vue?vue&type=template&id=38576ba8&scoped=true&"
import script from "./unboundPhone.vue?vue&type=script&lang=js&"
export * from "./unboundPhone.vue?vue&type=script&lang=js&"
import style0 from "./unboundPhone.vue?vue&type=style&index=0&id=38576ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38576ba8",
  null
  
)

export default component.exports